<div>
  <button
    *showAuthed="true"
    type="button"
    class="btn btn-sm btn-outline-primary"
    [ngClass]="{ disabled: isSubmitting }"
    (click)="commentEditorModal.show()"
  >
    <div class="row">
      <div style="display: inline-block">
        <i class="icofont icofont-reply reply-word"></i>
        <span class="reply-word"> Reply </span>
        <span
          class="reply-word"
          *ngIf="commentRepliedTo && commentRepliedTo.replyCount > 0"
        >
          ({{ commentRepliedTo.replyCount }})
        </span>
      </div>
    </div>
    <!-- Content marker -->
    <ng-content></ng-content>
  </button>

  <!-- Discussion-comments-modal -->
  <comment-editor-modal
    #commentEditorModal
    [currentUser]="currentUser"
    [discussion]="discussion"
    [currentPanelMember]="currentPanelMember"
    [commentRepliedTo]="commentRepliedTo"
    [hideFooter]="true"
  >
  </comment-editor-modal>
  <!-- Discussion-comments-modal -->
</div>
